<template>
  <div class="add-container">
    <div class="f">
      <div class="country">
        <language-select @click="handleCountryItem" :active="country.code" @codeChange="value => country = value" />
      </div>
      <div class="editContent">
        <div class="title bg-white f-b">
          <span>{{ topTitle }}</span>
          <i class="el-icon-close pointer" @click="$router.push('/operation/newFunction/list')"></i>
        </div>
        <div class="form bg-white">
          <div class="form_item f">
            <div class="form_item_label">
              <span class="required">*</span>
              标题:
            </div>
            <el-input style="width: 800px" maxlength="250" show-word-limit v-model="params.title"></el-input>
          </div>
          <div v-if="type == 2" class="form_item f">
            <div class="form_item_label">
              <span class="required">*</span>
              发送用户:
            </div>
            <el-select v-model="params.sendUserType" placeholder="请选择">
              <el-option label="所有用户" value="1" />
              <el-option label="指定用户" value="2" />
            </el-select>
          </div>
          <div class="form_item f">
            <div class="form_item_label">
              发送日期:
            </div>
            <el-date-picker
              v-model="sendTime"
              type="datetime"
              placeholder="选择日期"
              :picker-options="dateOption">
            </el-date-picker>
            <div class="tip">未选择发送日期则默认创建成功后立即发送</div>
          </div>
          <div v-if="params.sendUserType == 2" class="form_item f">
            <div class="form_item_label">
              <span class="required">*</span>
              用户邮箱:
            </div>
            <el-input v-model="userMail" style="width: 900px" type="textarea" placeholder="输入用户邮箱"></el-input>
          </div>
          <div class="form_item f">
            <div class="form_item_label"></div>
            <RichEditor :value="params.content" @input="data => (params.content = data)" style="width: 1360px"></RichEditor>
          </div>
          <div class="f-e" style="width: 1460px;">
            <el-button v-if="$route.query.isLook" type="primary" @click="$router.back()">返回</el-button>
            <template v-else>
              <el-button @click="$router.push('/operation/newFunction/list')">取消</el-button>
              <el-button type="primary" :loading="loading" @click="submit">确认</el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import languageSelect from './components/languageSelect.vue'
import RichEditor from '@/views/operation/copywriting/components/RichEditor.vue'
import API from '@/api'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: {
    languageSelect, RichEditor
  },
  data() {
    return {
      type: 1,
      country: {}, // 当前选中的国家
      sendTime: undefined,
      topTitle: '站内信新增',
      params: {
        title: undefined,
        content: '',
        id: undefined,
        sendUserType: '1'
      },
      dateOption: {
        disabledDate(time) {
					return time.getTime() < (Date.now() - 3600 * 1000 * 24)   //time是禁用时间
				}
      },
      userMail: '',
      loading: false
    }
  },
  created() {
    this.type = +this.$route.query.type || 1
    if(this.$route.query.id !== undefined) {
      this.topTitle = this.type == 1 ? '公告编辑' : '站内信编辑'
      this.params.id = this.$route.query.id
      this.newFunctionStationLetter(this.params.id)
    } else this.topTitle = this.type == 1 ? '公告新增' : '站内信新增'
    if (this.$route.query.isLook) this.topTitle = '站内信查看'
  },
  methods: {
    // 左侧 - 点击每个国家触发的事件
    handleCountryItem(country) {
      if (country.code === this.country.code) return
      this.country = country
    },
    newFunctionStationLetter(id) {
      API.newFunctionStationLetter({id}).then(res=>{
        this.params = Object.assign(this.params, res.data)
        if (this.type == 2) {
          this.params.sendUserType = res.data.sendUserType+''
          this.userMail = res.data.recipientList
        }
        this.sendTime = moment(res.data.sendTime)
      })
    },
    submit() {
      this.paramsFormat().then(params=>{
        this.loading = true
        if (this.type == 2 && params.sendUserType == 2) this.emailRegisterInfo(params)
        else this.newFunctionEdit(params)
      })
    },
    // 获取邮箱是否注册
    emailRegisterInfo(params) {
      API.emailRegisterInfo(params.recipientList).then((res) => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (res.data.length === params.recipientList.length) this.newFunctionEdit(params)
        else {
          let emailList = _.cloneDeep(params.recipientList)
          _.pull(emailList, ...res.data.map(t => t.email));
          this.$message.error(emailList.join('，')+'邮箱未注册')
        }
      }).finally(() => {
        this.loading = false
      })
    },

    newFunctionEdit(params) {
      this.loading = true
      API.newFunctionEdit(params).then(res=>{
        if(res.code !== 10000) {
          this.$message.error(res.message)
          return
        }
        this.$message.success(this.params.id ? '更改成功' : '新增成功')
        this.$router.push('/operation/newFunction/list?type='+this.type)
      }).finally(() => {
        this.loading = false
      })
    },

    paramsFormat() {
      return new Promise((resolve, reject)=>{
            const params = {
            ...this.params,
            type: this.type,
            sendUserType: this.type == 1 ? undefined : this.params.sendUserType,
            languageId: this.country.code,
            sendTime: this.sendTime ? this.sendTime.valueOf() : new Date().getTime()
          }
          if(!this.params.title) {
            this.$message.error('标题不能为空')
            reject()
          }
          if(!this.params.content) {
            this.$message.error('内容不能为空')
            reject()
          }
          if(this.type===2&&this.params.sendUserType==2&&!this.userMail) {
            this.$message.error('用户邮箱不能为空')
            reject()
          }
          if(this.type===2&&this.params.sendUserType==2&&this.userMail) {
            let separator = /,|\n/
            let recipientList = this.userMail.split(separator)
            params.recipientList = recipientList.filter(item => !!item)
          }
          let imgTag = /<img.*?src=[\\"|\\']?(.*?)[\\"|\\']?\s.*?>/ig
          let newContent = params.content
          let imgTagArr = params.content.match(imgTag) || []
          imgTagArr = imgTagArr.filter(e=>e.length > 1000)
          /*
            fileArr
            将富文本中的图片提取出base64编码转化为blob后统一上传文件服务器
          */
        if(imgTagArr.length) {
          const fileArr = []
          imgTagArr.forEach(tagAll=>{
            let getImgSrc =/\bsrc\b\s*=\s*[\\'\\"]?([^\\'\\"]*)[\\'\\"]?/ig
            let base64URLWithSrc = tagAll.match(getImgSrc)[0]
            let base64Code = base64URLWithSrc.replace('src="', '')
            base64Code = base64Code.slice(0, -1)
            function convertFile(dataurl) {
              let arr = dataurl.split(',')
              let mime = arr[0].match(/:(.*?);/)[1]
              let bstr = atob(arr[1])
              let n = bstr.length
              let u8arr = new Uint8Array(n)
              while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
              }
              return new File([u8arr], 'image', { type: mime === 'image/webp' ? 'image/jpeg' : mime })
            }
            let fileObj = convertFile(base64Code)
            fileArr.push({ tag: tagAll, file: fileObj, attr: base64URLWithSrc})
          })
          API.signValue({ directory: 'test/' }).then(({ data }) => {
                let formData = new FormData()
                formData.append('directory', 'test/')
                fileArr.forEach(file=>formData.append('fileList', file.file))
                formData.append('signValue', data)
                API.uploadFile(formData).then((result) => {
                  result.data.split(',').forEach((e,i)=>{
                    let newTag = fileArr[i].tag.replace(fileArr[i].attr, `src="${e}"`)
                    newContent = newContent.replace(fileArr[i].tag, newTag)
                  })
                  params.content = newContent
                })
                resolve(params)
          })
        } else {
          resolve(params)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-container {
  height: 100%;
  .country {
    width: 98px;
    height: 100%;
    min-width: 98px;
    margin-right: 5px;
    background-color: #fff;
    padding-top: 40px;
  }
  .editContent {
    flex: 1;
    min-height: 100%;
    .title {
      padding: 20px;
      margin-bottom: 10px;
    }
    .form {
      padding: 20px;
      height: 90%;
      .form_item {
        margin-bottom: 10px;
        position: relative;
        .form_item_label {
          width: 100px;
          text-align: right;
          height: 40px;
          line-height: 40px;
          margin-right: 8px;
        }
        .required {
          height: 40px;
          line-height: 40px;
          color: red;
        }
        .tip {
          color: #cac8c8;
          font-size: 12px;
          height: 40px;
          line-height: 40px;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
